/** @format */

export { connect } from './connect'
export { multiConnect, Props, Component } from './multiConnect'
